export default __webpack_public_path__ + "static/banner_tinyrainboots-b261c198b4706b6500f5a54c4a7ef76e.png";